<style lang="scss" scoped>
.el-button {
  width: 60px;
  margin-left: 10px;
}
.table {
  background: #fff;
  height: 500px;
}
.blue {
  color: #173bcf;
}
.pager {
  text-align: center;
}
.ul > li {
  margin-left: 5px;
}
/deep/ {
  .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: transparent;
  }
}
/deep/ .el-table th {
  background: #fff;
}
.img {
  width: 50px;
  height: 50px;
}
</style>

<template>
  <div>
    <div class="clearfix mt20 mb20">
      <div class="fl">
        渠道名称:
        <span class="blue">{{name}}</span>
        <span class="ml20">日期: {{date}}</span>
      </div>
      <down-load :tdata="downloadStr" filename=".fansdetail">
        <span href class="fr blue">
          <i class="iconfont iconxiazai1"></i>下载表格
        </span>
      </down-load>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="头像">
          <template slot-scope="scope">
            <img class="img" :src="scope.row.headImg" alt />
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="location" label="国家/省份/城市"></el-table-column>
        <el-table-column label="关注时间">
          <template slot-scope="scope">
            <div>{{momentutc(scope.row.subscribedDate,'YYYY-MM-DD')}}</div>
          </template>
        </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <ul class="clearfix ul">
              <li
                v-for="item in scope.row.customTags"
                :key="item.customTagId"
                class="fl"
              >·{{item.name}}</li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt40">
      <el-pagination
        class="pager"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import DownLoad from '@/components/download';
import moment from 'moment';
export default {
  components: {
    DownLoad,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      value: [],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      date: '',
      name: '',
      downloadStr: '',
    };
  },

  async mounted() {
    await this.getData();
    this.getAllData();
  },
  methods: {
    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async getData() {
      let date = this.moment(Number(this.$route.query.date), 'YYYY-MM-DD');
      let res = await this.$http.get(
        `/api/${this.id}/analyze/channel/qrcode/${this.$route.query.id}/day?page=${this.page}&size=${this.pageSize}&day=${date}`,
      );
      console.log(res);
      this.tableData = res.followers.list;
      this.total = res.followers.totalSize;
      this.name = res.name;
      this.date = date;
    },
    async getAllData() {
      let date = this.moment(Number(this.$route.query.date), 'YYYY-MM-DD');
      let res = await this.$http.get(
        `/api/${this.id}/download/channel/qrcode/${this.$route.query.id}/day`,
        {
          params: {
            page: 1,
            size: 10000000,
            day: date,
          },
          responseType: 'blob',
        },
      );

      if (res) {
        this.downloadStr = res;
      }
    },
  },
};
</script>
